var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIos({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "ffbeade2-01cc-46a9-9e3c-d71013c5a4f2"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "3b5e0d99-637c-4eaa-968c-9b36b51de617"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(10.69 0 0 10.69 540 540)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-50.49, -50)",
    d: "M 62.7485 21.6237 C 64.3237 19.8082 65.5248 17.6994 66.2827 15.4184 C 67.0407 13.1375 67.3406 10.7292 67.1652 8.33203 C 62.3293 8.72239 57.8402 10.9968 54.6652 14.6654 C 53.1448 16.4236 51.9926 18.469 51.2769 20.6805 C 50.5612 22.8921 50.2965 25.2247 50.4985 27.5404 C 52.8575 27.56 55.1893 27.0366 57.3135 26.0106 C 59.4377 24.9846 61.2974 23.4836 62.7485 21.6237 Z M 73.2485 52.6237 C 73.2765 49.4309 74.1175 46.2979 75.6922 43.5204 C 77.2668 40.7428 79.5233 38.4123 82.2485 36.7487 C 80.5286 34.2705 78.255 32.2272 75.6079 30.7807 C 72.9608 29.3342 70.0131 28.5243 66.9985 28.4154 C 60.4985 27.7487 54.4985 32.207 51.0402 32.207 C 47.5819 32.207 42.7069 28.4987 37.2902 28.582 C 33.7491 28.6987 30.2986 29.7311 27.2754 31.5786 C 24.2522 33.4262 21.7594 36.0257 20.0402 39.1237 C 12.7069 51.8737 18.1652 70.832 25.4985 81.1237 C 28.8319 86.1654 32.9985 91.8737 38.4985 91.6654 C 43.9985 91.457 45.7902 88.2487 52.1652 88.2487 C 58.5402 88.2487 60.4985 91.6654 65.9152 91.5404 C 71.3319 91.4154 75.1652 86.3737 78.6652 81.332 C 81.1445 77.6717 83.0813 73.672 84.4152 69.457 C 81.113 68.0488 78.2957 65.704 76.3112 62.7125 C 74.3267 59.7209 73.262 56.2136 73.2485 52.6237 Z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIos);
export default __webpack_public_path__ + "static/media/ios.31d9ad1d67a3d357017ebcc8c630745a.svg";
export { ForwardRef as ReactComponent };